import React, { useState } from 'react';
import { Wallet, LogOut, X } from 'lucide-react';
import { useWallet } from './WalletContext';

const MetaMaskIcon = () => (
  <svg viewBox="0 0 35 33" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <path d="M32.9582 1L19.4834 11.3506L21.9615 5.60796L32.9582 1Z" fill="#E17726" stroke="#E17726" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2.65789 1L16.0085 11.4428L13.654 5.60796L2.65789 1Z" fill="#E27625" stroke="#E27625" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M28.1662 23.6744L24.5316 29.3471L32.0981 31.5137L34.3577 23.7767L28.1662 23.6744Z" fill="#E27625" stroke="#E27625" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M1.27271 23.7767L3.51904 31.5137L11.0854 29.3471L7.45082 23.6744L1.27271 23.7767Z" fill="#E27625" stroke="#E27625" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10.7176 14.3673L8.61963 17.4788L16.1288 17.8316L15.8541 9.67578L10.7176 14.3673Z" fill="#E27625" stroke="#E27625" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M24.898 14.3673L19.6854 9.58301L19.4834 17.8316L26.9926 17.4788L24.898 14.3673Z" fill="#E27625" stroke="#E27625" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.0854 29.3471L15.6914 27.0981L11.6726 23.8311L11.0854 29.3471Z" fill="#E27625" stroke="#E27625" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M19.9242 27.0981L24.5316 29.3471L23.943 23.8311L19.9242 27.0981Z" fill="#E27625" stroke="#E27625" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M24.5316 29.3471L19.9242 27.0981L20.3026 30.0878L20.2612 31.421L24.5316 29.3471Z" fill="#D5BFB2" stroke="#D5BFB2" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.0854 29.3471L15.3558 31.421L15.3271 30.0878L15.6914 27.0981L11.0854 29.3471Z" fill="#D5BFB2" stroke="#D5BFB2" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M15.4199 22.0203L11.5425 20.8672L14.3158 19.5732L15.4199 22.0203Z" fill="#233447" stroke="#233447" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M20.1957 22.0203L21.2998 19.5732L24.086 20.8672L20.1957 22.0203Z" fill="#233447" stroke="#233447" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.0854 29.3471L11.6997 23.6744L7.45082 23.7767L11.0854 29.3471Z" fill="#CC6228" stroke="#CC6228" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M23.9158 23.6744L24.5316 29.3471L28.1662 23.7767L23.9158 23.6744Z" fill="#CC6228" stroke="#CC6228" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M26.9926 17.4788L19.4834 17.8316L20.1971 22.0203L21.3012 19.5732L24.0874 20.8672L26.9926 17.4788Z" fill="#CC6228" stroke="#CC6228" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.5425 20.8672L14.3286 19.5732L15.4199 22.0203L16.1288 17.8316L8.61963 17.4788L11.5425 20.8672Z" fill="#CC6228" stroke="#CC6228" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.61963 17.4788L11.6726 23.8311L11.5425 20.8672L8.61963 17.4788Z" fill="#E27525" stroke="#E27525" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M24.0874 20.8672L23.943 23.8311L26.9926 17.4788L24.0874 20.8672Z" fill="#E27525" stroke="#E27525" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16.1288 17.8316L15.4199 22.0203L16.3037 26.5486L16.5098 20.5335L16.1288 17.8316Z" fill="#E27525" stroke="#E27525" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M19.4834 17.8316L19.1138 20.5221L19.3118 26.5486L20.1971 22.0203L19.4834 17.8316Z" fill="#E27525" stroke="#E27525" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M20.1971 22.0203L19.3118 26.5486L19.9242 27.0981L23.943 23.8311L24.0874 20.8672L20.1971 22.0203Z" fill="#F5841F" stroke="#F5841F" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.5425 20.8672L11.6726 23.8311L15.6914 27.0981L16.3037 26.5486L15.4199 22.0203L11.5425 20.8672Z" fill="#F5841F" stroke="#F5841F" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M20.2612 31.421L20.3026 30.0878L19.9499 29.7797H15.6654L15.3271 30.0878L15.3558 31.421L11.0854 29.3471L12.6137 30.5978L15.6269 32.6717H19.9886L23.0018 30.5978L24.5316 29.3471L20.2612 31.421Z" fill="#C0AC9D" stroke="#C0AC9D" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M19.9242 27.0981L19.3118 26.5486H16.3037L15.6914 27.0981L15.3271 30.0878L15.6654 29.7797H19.9499L20.3026 30.0878L19.9242 27.0981Z" fill="#161616" stroke="#161616" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M33.4997 11.8854L34.6554 6.40354L32.9582 1L19.9242 10.8458L24.898 14.3673L32.0337 16.4066L33.5647 14.5942L32.9152 14.1203L34.0023 13.1311L33.2058 12.5137L34.2929 11.6701L33.4997 11.8854Z" fill="#763E1A" stroke="#763E1A" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M1 6.40354L2.15568 11.8854L1.34888 11.6701L2.43595 12.5137L1.64071 13.1311L2.72778 14.1203L2.07828 14.5942L3.60928 16.4066L10.7176 14.3673L15.6914 10.8458L2.65789 1L1 6.40354Z" fill="#763E1A" stroke="#763E1A" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M32.0337 16.4066L24.898 14.3673L26.9926 17.4788L23.943 23.8311L28.1662 23.7767H34.3577L32.0337 16.4066Z" fill="#F5841F" stroke="#F5841F" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10.7176 14.3673L3.60928 16.4066L1.27271 23.7767H7.45082L11.6726 23.8311L8.61963 17.4788L10.7176 14.3673Z" fill="#F5841F" stroke="#F5841F" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M19.4834 17.8316L19.9242 10.8458L21.9757 5.60796H13.654L15.6914 10.8458L16.1288 17.8316L16.2905 20.5449L16.3037 26.5486H19.3118L19.3251 20.5449L19.4834 17.8316Z" fill="#F5841F" stroke="#F5841F" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const OKXIcon = () => (
  <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <rect width="200" height="200" rx="40" fill="#CDFA50"/>
    <g transform="translate(30, 30)">
      <rect x="0" y="48" width="38" height="38" rx="7" fill="#000000"/>
      <rect x="51" y="0" width="38" height="38" rx="7" fill="#000000"/>
      <rect x="51" y="48" width="38" height="38" rx="7" fill="#000000"/>
      <rect x="51" y="96" width="38" height="38" rx="7" fill="#000000"/>
      <rect x="102" y="48" width="38" height="38" rx="7" fill="#000000"/>
    </g>
  </svg>
);

const WalletButton = () => {
  const { isConnected, walletAddress, balance, walletType, formatAddress, disconnect, connect } = useWallet();
  const [isConnecting, setIsConnecting] = useState(false);
  const [showWalletModal, setShowWalletModal] = useState(false);
  const [error, setError] = useState('');

  const wallets = [
    {
      type: 'metamask',
      name: 'MetaMask',
      icon: <MetaMaskIcon />,
      color: 'from-orange-500 to-orange-600',
      description: 'Connect to MetaMask',
      available: typeof window !== 'undefined' && window.ethereum
    },
    {
      type: 'okx',
      name: 'OKX Wallet',
      icon: <OKXIcon />,
      color: 'from-lime-400 to-lime-500',
      description: 'Connect to OKX Wallet',
      available: typeof window !== 'undefined' && window.okxwallet
    }
  ];

  const handleConnectClick = () => {
    setShowWalletModal(true);
    setError('');
  };

  const handleWalletSelect = async (walletType) => {
    setIsConnecting(true);
    setError('');
    
    try {
      await connect(walletType);
      setShowWalletModal(false);
    } catch (err) {
      setError(err.message || 'Failed to connect wallet');
    } finally {
      setIsConnecting(false);
    }
  };

  const handleDisconnectClick = () => {
    disconnect();
  };

  if (!isConnected) {
    return (
      <>
        <button
          onClick={handleConnectClick}
          className="inline-flex items-center gap-2 bg-gradient-to-r from-[#476bff] to-[#50ffff] hover:opacity-90 text-white rounded-xl px-6 py-3 font-bold transition-all duration-300 hover:scale-105 shadow-lg"
        >
          <Wallet className="w-5 h-5" />
          Connect Wallet
        </button>

        {showWalletModal && (
          <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
            <div className="bg-gradient-to-br from-gray-900 to-black rounded-2xl shadow-2xl max-w-md w-full border border-gray-800 animate-scale-in">
              <div className="p-6 border-b border-gray-800 flex items-center justify-between">
                <h2 className="text-2xl font-black text-white">Select Wallet</h2>
                <button
                  onClick={() => {
                    setShowWalletModal(false);
                    setError('');
                  }}
                  className="text-gray-400 hover:text-white transition"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>

              <div className="p-6">
                {error && (
                  <div className="bg-red-900/30 border border-red-500 rounded-xl p-4 mb-4 flex items-start gap-3">
                    <p className="text-sm text-red-300">{error}</p>
                  </div>
                )}

                <div className="space-y-3">
                  {wallets.map((wallet) => (
                    <button
                      key={wallet.type}
                      onClick={() => handleWalletSelect(wallet.type)}
                      disabled={!wallet.available || isConnecting}
                      className={`w-full bg-gradient-to-r from-gray-800 to-black hover:from-gray-700 hover:to-gray-900 border border-gray-700 hover:border-gray-600 rounded-xl p-4 flex items-center gap-4 transition-all duration-300 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed ${
                        !wallet.available ? 'opacity-50' : ''
                      }`}
                    >
                      <div className="w-14 h-14 rounded-xl flex items-center justify-center p-1.5">
                        {wallet.icon}
                      </div>
                      <div className="text-left flex-1">
                        <p className="font-bold text-white text-lg">{wallet.name}</p>
                        <p className="text-xs text-gray-400">
                          {wallet.available ? wallet.description : 'Not installed'}
                        </p>
                      </div>
                      {isConnecting && (
                        <div className="w-5 h-5 border-2 border-[#50ffff] border-t-transparent rounded-full animate-spin"></div>
                      )}
                    </button>
                  ))}
                </div>

                <div className="mt-6 bg-gray-800/50 rounded-xl p-4">
                  <p className="text-xs text-gray-400 text-center">
                    By connecting a wallet, you agree to the Terms of Service and Privacy Policy
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        <style jsx>{`
          @keyframes scale-in {
            from {
              opacity: 0;
              transform: scale(0.95);
            }
            to {
              opacity: 1;
              transform: scale(1);
            }
          }
          .animate-scale-in {
            animation: scale-in 0.2s ease-out;
          }
        `}</style>
      </>
    );
  }

  const getWalletName = () => {
    if (walletType === 'okx') return 'OKX Wallet';
    return 'MetaMask';
  };

  return (
    <div className="flex items-center gap-3">
      <div className="bg-gradient-to-br from-gray-900 to-black border-2 border-[#476bff] rounded-xl px-4 py-2 flex items-center gap-3">
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></div>
          <div>
            <p className="text-xs text-gray-400">{getWalletName()}</p>
            <p className="text-sm font-bold text-white font-mono">{formatAddress(walletAddress)}</p>
          </div>
        </div>
        <div className="border-l border-gray-700 pl-3">
          <p className="text-xs text-gray-400">Balance</p>
          <p className="text-sm font-bold text-[#50ffff]">{balance} ETH</p>
        </div>
      </div>
      
      <button
        onClick={handleDisconnectClick}
        className="bg-red-500 hover:bg-red-600 text-white rounded-xl px-4 py-3 flex items-center gap-2 font-bold transition-all duration-300 hover:scale-105"
        title="Disconnect Wallet"
      >
        <LogOut className="w-4 h-4" />
      </button>
    </div>
  );
};

export default WalletButton;